import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import CkEditorInput from "@/containers/Company/components/Notice/CkEditorInput";
import { GET_ALL_DEPARTMENT } from "@/GraphQL/Queries";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_DEPARTMENT_KPI } from "@/GraphQL/Mutation";
import { toast } from "react-toastify";

export default function DepartmentKpiModal({ modal, toggle, id }) {
  // Fetch departments
  const { data } = useQuery(GET_ALL_DEPARTMENT);
  const allDept = data?.getAllDepartments?.data || [];
  const [createDepartmentKpi, { loading, error }] = useMutation(
    CREATE_DEPARTMENT_KPI
  );
  // Convert departments into dropdown options
  const deptOptions = allDept.map((dept) => ({
    value: dept.id,
    label: dept.name,
  }));

  const defaultDeptId = id;

  // Setup form with default dept_id
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      dept_id: defaultDeptId,
      key_area: "",
      description: "",
      weight: "",
    },
  });

  const onSubmit = async (data) => {
    console.log("✅ KPI Submitted:", data);
    try {
      const { data: response } = await createDepartmentKpi({
        variables: {
          key_area: data.key_area,
          description: data.description,
          dept_id: Number(data.dept_id),
          weight: data.weight,
        },
      });

      console.log("✅ KPI created:", response.createDepartmentKpi);
      toast.success("KPI created successfully!");
      toggle(); // close modal
      reset();
    } catch (err) {
      console.error("❌ KPI creation failed:", err);
      toast.error("Failed to create KPI.");
    }
    // toggle();
    // reset();
  };

  return (
    <>
      <Button color="primary" onClick={toggle}>
        Create KPI
      </Button>

      <Modal isOpen={modal} toggle={toggle}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Create Department KPI</ModalHeader>
          <ModalBody>
            {/* Key Area */}
            <FormGroup>
              <Label className="form__form-group-label">Key Area</Label>
              <Controller
                name="key_area"
                control={control}
                rules={{ required: "Key Area is required" }}
                render={({ field }) => (
                  <Input
                    type="text"
                    placeholder="Enter key area"
                    value={field.value ?? ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      console.log("🚀 ~ DepartmentKpiModal ~ val:", val);
                      field.onChange(val);
                    }}
                  />
                )}
              />
              {errors.key_area && (
                <small className="text-danger">{errors.key_area.message}</small>
              )}
            </FormGroup>

            {/* Department Dropdown */}
            <FormGroup>
              <Label className="form__form-group-label ">Department</Label>
              <Controller
                name="dept_id"
                control={control}
                rules={{ required: "Department is required" }}
                render={({ field }) => (
                  <Input
                    type="select"
                    className="form-control"
                    disabled
                    readOnly={true}
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                  >
                    <option value="" disabled>
                      Select a department
                    </option>
                    {deptOptions.map((dept) => (
                      <option key={dept.value} value={dept.value}>
                        {dept.label}
                      </option>
                    ))}
                  </Input>
                )}
              />
              {errors.dept_id && (
                <small className="text-danger">{errors.dept_id.message}</small>
              )}
            </FormGroup>
            {/* Weight */}
            <FormGroup>
              <Label>Weight</Label>
              <Controller
                name="weight"
                control={control}
                rules={{ required: "Weight is required" }}
                render={({ field }) => (
                  <Input
                    type="number"
                    step="any"
                    placeholder="Enter weight"
                    value={field.value ?? ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      field.onChange(val === "" ? null : parseFloat(val));
                    }}
                  />
                )}
              />
            </FormGroup>

            {/* Description */}
            <FormGroup>
              <Label className="form__form-group-label">Description</Label>
              <Controller
                name="description"
                control={control}
                rules={{ required: "Description is required" }}
                render={({ field }) => (
                  <CkEditorInput
                    onChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
              {errors.description && (
                <small className="text-danger">
                  {errors.description.message}
                </small>
              )}
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button color="danger" type="button" onClick={toggle}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Submit
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}
